import React, { useCallback } from 'react';
import { Typography } from 'antd';
import { LinkProps } from 'antd/lib/typography/Link';
import { useHistory } from 'react-router-dom';

export type RouterLinkProps<P = any> = Omit<LinkProps, 'onClick'> & {
  to: string;
  component?: React.ElementType<P>;
  prevent?:boolean;
} & P;

/**
 * @link https://ant.design/components/typography/#FAQ
 *
 * Example from the documentation causes page to reload.
 * This component is a workaround until it is fixed in Ant Design.
 *
 * Example from the documentation:
 * ```tsx
 * <Link to="/" component={Typography.Link} />
 * ```
 */
const RouterLink = (props: RouterLinkProps) => {
  const { to, component,prevent, ...rest } = props;

  const Component = component ?? Typography.Link;

  const history = useHistory();

  const onClick = useCallback(
    (event: React.FormEvent<HTMLAnchorElement>) => {
      if(!prevent)
      event.preventDefault();
      history.push(to);
    },
    [history, prevent, to]
  );

  return <Component onClick={onClick} href={to} {...rest} />;
};

export default RouterLink;
